import { render, staticRenderFns } from "./dataDetail.vue?vue&type=template&id=75dea18c&scoped=true"
import script from "./dataDetail.vue?vue&type=script&lang=js"
export * from "./dataDetail.vue?vue&type=script&lang=js"
import style0 from "./dataDetail.vue?vue&type=style&index=0&id=75dea18c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dea18c",
  null
  
)

export default component.exports